import * as React from "react";
import { Link } from "react-router-dom";
import usePluginEntities from "hooks/usePluginEntities";
import { NavDropdown } from "components/bootstrap";
import { Icon } from "components/common";
import useHotkeysContext from "hooks/useHotkeysContext";
import Menu from "components/bootstrap/Menu";
import NavIcon from "components/navigation/NavIcon";
import usePermissions from "hooks/usePermissions";
const HelpMenu = () => {
  const { setShowHotkeysModal } = useHotkeysContext();
  const menuItems = usePluginEntities("helpMenu");
  const { isPermitted } = usePermissions();
  const availableMenuItems = menuItems.filter((item) => isPermitted(item.permissions));
  return /* @__PURE__ */ React.createElement(NavDropdown, { title: /* @__PURE__ */ React.createElement(NavIcon, { type: "help" }), hoverTitle: "Help", noCaret: true }, availableMenuItems.map((item) => {
    if ("externalLink" in item) {
      return /* @__PURE__ */ React.createElement(
        Menu.Item,
        {
          key: item.description,
          component: "a",
          href: item.externalLink,
          target: "_blank",
          leftSection: /* @__PURE__ */ React.createElement(Icon, { name: "open_in_new" })
        },
        item.description
      );
    }
    if ("path" in item) {
      return /* @__PURE__ */ React.createElement(Menu.Item, { key: item.description, component: Link, to: item.path }, item.description);
    }
    if ("action" in item) {
      return /* @__PURE__ */ React.createElement(
        Menu.Item,
        {
          key: item.description,
          onClick: () => item.action({ showHotkeysModal: () => setShowHotkeysModal(true) })
        },
        item.description
      );
    }
    throw Error("Help menu item must have either external link, path, or action defined");
  }));
};
export default HelpMenu;
